import { Link } from "react-router-dom";
import { SEO, OrganizationJsonLd } from "@/components/SEO";
import backgroundVideo from "@/assets/background.mov.asset.json";

const categories = [
  { label: "NEW ARRIVALS", to: "/new" },
  { label: "TEES", to: "/collection?category=tees" },
  { label: "SWEATS", to: "/collection?category=sweats" },
  { label: "HEADWEAR", to: "/collection?category=headwear" },
  { label: "OUTERWEAR", to: "/collection?category=outerwear" },
  { label: "KNITS", to: "/collection?category=knits" },
  { label: "TOPS & SHIRTS", to: "/collection?category=tops" },
  { label: "SHORTS", to: "/collection?category=shorts" },
  { label: "PANTS", to: "/collection?category=pants" },
  { label: "DENIM", to: "/collection?category=denim" },
  { label: "ACCESSORIES", to: "/collection?category=accessories" },
  { label: "ARCHIVE", to: "/collection" },
  { label: "SUPPORT", to: "/contact" },
  { label: "ACCOUNT", to: "/profile" },
  { label: "LEGAL", to: "/terms-of-service" },
];

const Index = () => {
  return (
    <div className="h-screen w-screen overflow-hidden bg-black text-gray-500 flex flex-col relative">
      <SEO url="/" />
      <OrganizationJsonLd />

      {/* Background video */}
      <video
        className="absolute inset-0 w-full h-full object-cover z-0 pointer-events-none"
        src={backgroundVideo.url}
        autoPlay
        loop
        muted
        playsInline
        aria-hidden="true"
      />

      {/* Top-right utility links */}
      <div className="absolute top-4 right-6 flex gap-6 text-xs uppercase tracking-widest z-10">
        <Link to="/collection" className="hover:text-gray-300 transition-colors">Search</Link>
        <Link to="/cart" className="hover:text-gray-300 transition-colors">Bag</Link>
      </div>

      <aside className="flex-1 min-h-0 flex flex-col px-6 py-6 relative z-10">
        {/* Logo */}
        <Link
          to="/"
          className="font-display text-3xl md:text-4xl tracking-wider text-gray-500 hover:text-gray-300 transition-colors mb-4"
          lang="ja"
        >
          ユニオン
        </Link>

        {/* Categories */}
        <nav aria-label="Categories" className="flex flex-col gap-2">
          {categories.map((c) => (
            <Link
              key={c.label}
              to={c.to}
              className="text-[11px] md:text-xs uppercase tracking-widest leading-tight hover:text-gray-300 transition-colors w-fit py-[2px]"
            >
              {c.label}
            </Link>
          ))}
        </nav>

        {/* Footer / copyright */}
        <div className="mt-auto pt-4 text-[10px] uppercase tracking-widest text-gray-600">
          © {new Date().getFullYear()} Union Collection
        </div>
      </aside>
    </div>
  );
};

export default Index;
